/// <amd-module name="WorkItemsHub/WorkItemsHubShortcutGroup" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssKeyboardShortcutService } from "VSS/Platform/KeyboardShortcuts";
import * as Resources from "WorkItemsHub/Resources";
import { WorkItemsHubView } from "./Components/WorkItemsHubView";
import { WorkItemsHubCommandProvider } from "./DataProviders/WorkItemsHubCommandProvider";

export class WorkItemsHubShortcutGroup {
    private _commandProvider: WorkItemsHubCommandProvider = null;
    private _workItemsHubView: WorkItemsHubView = null;

    constructor(commandProvider: WorkItemsHubCommandProvider, workItemsHubView: WorkItemsHubView) {
        this._commandProvider = commandProvider;
        this._workItemsHubView = workItemsHubView;
    }

    public ReRegisterWorkItemsHubShortcuts(pageContext: IVssPageContext): void {
        const shortcutService = pageContext.getService<IVssKeyboardShortcutService>("IVssKeyboardShortcutService");

        shortcutService.registerShortcut(Resources.KeyboardShortcutGroup_Work, {
            combos: ["z"],
            description: Resources.KeyboardShortcutDescription_ToggleFullScreen,
            action: () => {
                this._workItemsHubView.toggleFullScreen();
            }
        });

        shortcutService.registerShortcut(Resources.WorkItemsHubTitle, {
            combos: ["mod+shift+f"],
            description: Resources.FilterResults,
            action: () => {
                this._workItemsHubView.activateFilter();
            }
        });

        shortcutService.registerShortcut(Resources.WorkItemsHubTitle, {
            combos: ["mod+c"],
            description: Resources.CopyToClipboard,
            element: ".region-page",
            action: () => {
                this._commandProvider.copyWorkItemsToClipboard(pageContext, true);
            }
        });

        if (this._commandProvider.getDeleteHelper().hasDeletePermission()) {
            shortcutService.registerShortcut(Resources.WorkItemsHubTitle, {
                combos: ["del"],
                description: Resources.DeleteSelectedWorkItems,
                element: ".work-items-tab-content",
                action: () => {
                    this._commandProvider.deleteWorkItems(pageContext, true);
                }
            });
        }
    }
}
